<template>
  <div class="achievement-external">
    <!-- 顶部选择条件和一些按钮 -->
    <achievementTopBar
      @deleteClick="deleteClick"
      @editClick="editClick"
      @search="search"
      :gradeList="gradeList"
      :examTitleList="examTitleList"
      :gradeExamInfoList="gradeExamInfoList"
    />
    <!-- 成绩列表 -->
    <div class="achievement-list" v-bitmap="getListResult">
      <achievementListItem
        class="achievement-list-item"
        v-for="(item, index) in achievementList"
        :key="index"
        :achievementItem="item"
        v-show="total"
        @click.native="itemClick(item)"
        @editClick="editClick"
        :class="{ choose: chooseId == item.id }"
      />
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <pagination
        :total="parseInt(total)"
        :pageSize="parseInt(pageSize)"
        @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <externalScoreEditDialog
      v-show="externalScoreEditShow"
      :externalScoreEditShow.sync="externalScoreEditShow"
      :editItemData="editItemData"
      :schoolCourseList="schoolCourseList"
      @externalScoreEditConfirm="externalScoreEditConfirm"
    />
  </div>
</template>

<script>
import achievementTopBar from "./components/achievement-top-bar/achievementTopBar.vue";
import pagination from "@/components/pagination/pagination";
import achievementListItem from "./components/achievement-item/achievement-item.vue";
import externalScoreEditDialog from "./components/external-score-edit-dialog/externalScoreEditDialog.vue";
export default {
  components: {
    pagination,
    achievementTopBar,
    achievementListItem,
    externalScoreEditDialog,
  },
  data() {
    return {
      getListResult: "success", // nullData, error, loading
      chooseId: -1,
      chooseItem: {},
      gradeList: [], // 年级列表
      // 分页参数
      total: 0, // 总条数
      pageNum: 1, // 当前页码
      pageSize: 9, // 每页条数
      externalScoreEditShow: false, // 修改校外成绩弹窗
      achievementList: [], // 校外成绩列表
      examTitleList: [], // 考试主标题列表
      gradeExamInfoList: [], // 考试信息列表
      // 查询参数
      searchData: {
        gradeId: "",
        title: "",
        subTitle: "",
        outsideSchoolSign: "",
        examInfoId: "",
      },
      editItemData: {}, // 修改校外成绩弹窗数据
      schoolCourseList: [], // 科目列表
    };
  },
  provide() {
    return {
      refresh: this.refresh
    };
  },
  created() {
    // 获取学校科目列表
    this.getCourseList();
    // 获取年级列表
    this.getGradeList();
    // 获取考试主标题列表
    this.getSchoolExamTitle();
    // 获取年级考试信息列表
    this.getSchoolExamInfoByTeacher();
    // 获取校外成绩列表
    this.getExternalAchievementPC();
  },
  methods: {
    // 获取学校科目列表
    getCourseList() {
      this.get(this.$url.getCourseList).then((res) => {
        // console.log("获取学校科目列表：", res);
        if (res.code !== 200) return;
        let list = res.rows;
        let courseList = [];
        list.map((item) => {
          courseList.push({
            courseId: item.id,
            courseName: item.courseName,
            fullScore: "", // 分制分数
            checked: false, // 分制是否选中
            descriptors: [], // 分数指标列表
          });
        });

        this.schoolCourseList = courseList;
      });
    },
    search(e) {
      this.searchData = e;
      this.pageNum = 1;
      this.getExternalAchievementPC();
    },
    refresh() {
      // this.pageNum = 1;
      this.getExternalAchievementPC();
    },
     // 获取校外成绩列表
    getExternalAchievementPC() {
      let { title, subTitle, gradeId, outsideSchoolSign, examInfoId } =
        this.searchData;
      let data = {
        schoolId: this.user.schoolId,
        title,
        subTitle,
        gradeId,
        outsideSchoolSign,
        examInfoId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      // this.getListResult = "loading";
      this.get(this.$url.getExternalAchievementPC, data).then((res) => {
        // console.log("获取校外成绩列表:", res);
        if (res.code !== 200) {
          this.getListResult = "error";
          return this.$message.error(res.msg || "获取校外成绩列表失败");
        }
        this.getListResult = res.total === 0 ? "nullData" : "success";
        this.achievementList = res.rows;
        this.total = res.total;
      });
    },
    // 获取年级考试信息列表
    getSchoolExamInfoByTeacher() {
      let data = {
        schoolId: this.user.schoolId,
        pageSize: 10000,
        pageNum: 1,
      };
      this.get(this.$url.getSchoolExamInfoByTeacher, data).then((res) => {
        // console.log("获取年级考试信息列表", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "获取年级考试列表失败");
        this.gradeExamInfoList = res.rows;
      });
    },
    // 获取考试主标题列表
    getSchoolExamTitle() {
      let data = {
        schoolId: this.user.schoolId,
      };
      this.get(this.$url.getSchoolExamTitle, data).then((res) => {
        // console.log("获取考试主标题列表==>", res);
        if (res.code !== 200) return;
        this.examTitleList = res.data;
      });
    },
    // 校外成绩修改点击提交
    externalScoreEditConfirm(data) {
      this.put(this.$url.updateExternalAchievement, data).then((res) => {
        if (res.code !== 200)
          return this.$message.error(res.msg || "修改校外成绩失败");
        this.$message.success(res.msg);
        this.externalScoreEditShow = false;
        this.getExternalAchievementPC();
      });
    },
    // 获取年级列表
    getGradeList() {
      this.get(this.$url.getgradeList, {
        schoolId: this.school.id,
      }).then((res) => {
        if (res.code == 200) {
          this.gradeList = res.data;
        }
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getExternalAchievementPC();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getExternalAchievementPC();
    },
    deleteClick() {
      if (this.chooseId == -1) {
        return this.$message.warning("请点击选择一个考试");
      }
      this.$confirm("是否确定删除选中的校外成绩?", "删除校外成绩", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {})
        .catch(() => {});
    },
    editClick(item) {
      // console.log("editItem==>", item);
      // if (this.chooseId == -1) {
      //   return this.$message.warning("请点击选择一个考试");
      // }
      this.editItemData = item;
      this.externalScoreEditShow = true;
    },
    itemClick(item) {
      // this.chooseId = item.id;
      // this.chooseItem = item;
      // console.log(item);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./achievementExternal.scss";
</style>